export default "__VITE_ASSET__BuCV8YcE__"